import React, { useState, useEffect } from "react";
import TextInput from "../TextInput";

interface PhoneContactModel {
    country: string;
    number: string;
    ext: string;
}

interface PhoneContactProps {
    localizer: any;
    value: string;
    onValueChange?: (value: string) => void;
    isDisabled?: boolean;
}

const PhoneContact: React.FC<PhoneContactProps> = ({ localizer, value, onValueChange, isDisabled }) => {
    const parseValue = (input: string): PhoneContactModel => {
       
        return JSON.parse(input && input.trim() !== "" ? input : "{}") as PhoneContactModel;
        
    };

    const [phoneData, setPhoneData] = useState<PhoneContactModel>(parseValue(value));

    useEffect(() => {
        setPhoneData(parseValue(value));
    }, [value]);

    const handleInputChange = (field: keyof PhoneContactModel) => (newValue: string) => {
        const updatedData = { ...phoneData, [field]: newValue };
        setPhoneData(updatedData);
        onValueChange?.(JSON.stringify(updatedData));
    };

    return (
        <div className="row">
            <div className="col-sm-4">
                <label>Country</label>
                <TextInput
                    value={phoneData.country}
                    onValueChange={handleInputChange(localizer.localizeString("country"))}
                    disabled={isDisabled}
                />
            </div>
            <div className="col-sm-4">
                <label>Number</label>
                <TextInput
                    value={phoneData.number}
                    onValueChange={handleInputChange(localizer.localizeString("number"))}
                    disabled={isDisabled}
                />
            </div>
            <div className="col-sm-4">
                <label>Ext</label>
                <TextInput
                    value={phoneData.ext}
                    onValueChange={handleInputChange(localizer.localizeString("ext"))}
                    disabled={isDisabled}
                />
            </div>
        </div>
    );
};

export default PhoneContact;
